import { useMemo } from 'react';
import { Calendar } from 'lucide-react';
import { useClasseContext } from '../../../context/ClasseContext';

const formatYear = (period) => {
    if (!period?.date_debut || !period?.date_fin) return null;
    const start = new Date(period.date_debut).getFullYear();
    const end = new Date(period.date_fin).getFullYear();
    if (Number.isNaN(start) || Number.isNaN(end)) return null;
    return `${start}-${end}`;
};

const YearSelector = () => {
    const { ActivePeriode } = useClasseContext();

    const yearLabel = useMemo(() => {
        const fromContext = formatYear(ActivePeriode);
        if (fromContext) return fromContext;
        // Fallback : année scolaire courante (août → août)
        const today = new Date();
        const year = today.getFullYear();
        const startYear = today.getMonth() >= 7 ? year : year - 1;
        return `${startYear}-${startYear + 1}`;
    }, [ActivePeriode]);

    return (
        <div className="hidden md:inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-white border border-slate-200 text-[12.5px] text-slate-600 font-medium">
            <Calendar className="w-3.5 h-3.5 text-slate-400" />
            <span>{yearLabel}</span>
        </div>
    );
};

export default YearSelector;
